export const getExpectNumber = (
  isGetFrom: boolean,
  from?: number,
  to?: number
) => {
  return from && to && from - to > 0
    ? isGetFrom
      ? to
      : from
    : isGetFrom
    ? from
    : to
}
